import { combineReducers, type UnknownAction } from "redux";
import authReducer, { logout, setLogin } from "./auth";
import registerReducer from "./register";
import profileReducer from "./profile";
import projectReducer from "./project";
import workspaceReducer from "./workspace";
import changePasswordReducer from "./changePassword";
import changeEmailReducer from "./changeEmail";
import createProjectReducer from "./createProject";
import featuresReducer from "./features";
import { store } from "store/actions/store";
// import { create } from "domain";

const appReducer = combineReducers({
  auth: authReducer,
  register: registerReducer,
  profile: profileReducer,
  changePassword: changePasswordReducer,
  changeEmail: changeEmailReducer,
  createProject: createProjectReducer,
  project: projectReducer,
  workspace: workspaceReducer,
  features: featuresReducer,
});

export type AppState = ReturnType<typeof appReducer>;

/**
 * Every slice but `auth` holds the signed-in account's data (open workspace, project, forms).
 * Logout, or a sign-in as a different account, starts them all from their initial state so
 * the next account never boots with the previous account's ids. `auth` resets itself.
 * A new slice is covered without any extra logout step.
 */
const endsAccountState = (state: AppState | undefined, action: UnknownAction): boolean => {
  if (logout.match(action)) return true;
  if (!setLogin.match(action)) return false;
  const nextUserId = action.payload.data?.user?.user_id;
  return Boolean(nextUserId) && nextUserId !== state?.auth.user_id;
};

const rootReducer = (state: AppState | undefined, action: UnknownAction): AppState =>
  appReducer(endsAccountState(state, action) && state ? { auth: state.auth } : state, action);
export type AppDispatch = typeof store.dispatch;

export default rootReducer;
